<template>
    <iframe 
        id="eventRegIframe"
        class="iframeSel" 
        :src="ruta" 
        @load="onLoad = true; $emit('resizeIframe'); $emit('changeLoadingStep', false);"
        :style="{ width: '100%', minHeight: `${windowHeight}px`, heigh: 'auto' , display: onLoad ? 'block' : 'none' }"
    ></iframe>
</template>

<script>
import { mapState } from 'vuex';
import PaymentService from "@/services/PaymentService";

export default {
    data: () => ({
        eId: 0,
        windowHeight: 0,
        onLoad: false
    }),
    computed: {        
        ...mapState({
            languages(state) {
                return state.session.languages;
            },
            language(state) {
                return { languageId: state.session.languageId, languageCode: state.session.languageCode };
            },
            ruta(state) {
                return state.env.get('VUE_APP_ROOT') + '/admin/eventRegistration?eId=' + this.eId + '&disTopMenu=true';
            },
        })
    },
    methods: {
        breadCrumbStep1() {
            this.$router.push({ name: 'RegisterEventLegacy' });
        }
    },
    created() {
        PaymentService.hasUnpaidRegistrations().then(response =>{
            if(response.data.success == 1){
                this.hasUnpaidRegistrations = response.data.message;
                this.$store.dispatch('setUnPaidRegistrationAction', this.hasUnpaidRegistrations);
                if(this.hasUnpaidRegistrations != false){
                    this.$router.push({
                        name: 'UnPaidRegistrationDashboard'
                    });
                }
            }else{
                this.$store.dispatch('setUnPaidRegistrationAction', false);
                
            }
        });
    },
    mounted() {
        this.eId = this.$route.query.eId;
        this.windowHeight = window.innerHeight;
    },
    watch: {
        language(val) {
            if(this.onLoad && val) {
                let languageId = val.languageId;
                if(!languageId) {
                    languageId = this.languages.find(el => el.languageCode == val.languageCode);
                    languageId = languageId.id;
                }
                document.getElementById("eventRegIframe").contentWindow.updateLang(languageId);
            }
        }
    }
}
</script>